document.addEventListener('click', (event) => {
  const swatch = event.target.closest('.card-color-swatch');
  const card = swatch.closest('.card-wrapper');
  if (!swatch) return;
  
  const swatchWrapper = swatch.closest('.card-color-swatches');
  if (!swatchWrapper) return;
  
  const productId = swatchWrapper.dataset.productId;
  const image = document.querySelector(
    `[data-product-image="${productId}"]`
  );
  
  if (!image) return;
  
  const src = swatch.dataset.variantSrc;
  const srcset = swatch.dataset.variantSrcset;
  

  if (!src || !srcset) return;

  image.src = src;
  image.srcset = srcset;

  const label = card.querySelector('[data-selected-value]');
  if (label) {
    label.textContent = swatch.dataset.colorLabel;
  }

  // active state
  swatchWrapper
    .querySelectorAll('.card-color-swatch')
    .forEach(el => el.classList.remove('active'));

  swatch.classList.add('active');
});
